export const SHOW_MODAL_VAL = 'SHOW_MODAL_VAL';
export const CLOSE_MODAL_VAL = 'CLOSE_MODAL_VAL';

export const showAddComMod = () => ({
	type:SHOW_MODAL_VAL,
	payload:{comModVal:true}
})

export const closeAddComMod = () => ({
	type:CLOSE_MODAL_VAL,
	payload:{comModVal:false}
})